
type TextAndImageSectionProps = {
  title : string, 
  image : { 
    src : string, 
    alt : string, 
  },  
  height? : string,
  overlay? : boolean,
}

const TextAndImageSection = ({ 
  title, 
  image, 
  height, 
  overlay = false 
} : TextAndImageSectionProps) => {
  return (
    <div className='text-and-image-section'>
        {title ? <h2 className="title">{title}</h2> : ""}
        <div className="image-wrapper">
          {overlay ? <div className='overlay'></div> : ""}
          <img 
            src={image.src} 
            alt={image.alt} 
            style={{
              height : height,
            }}
            className={`section-image ${overlay ? "overlay" : ""}`} 
          />   
        </div>
    </div>
  )
}

export default TextAndImageSection